import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Store the initial content immediately from the hidden field if available
    const hiddenField = document.getElementById('page_right_column_text')
    if (hiddenField && hiddenField.value) {
      // This will be the already-converted HTML
      this.originalHtmlContent = hiddenField.value
      this.savedContent = hiddenField.value // Initialize savedContent
    }
    
    // Also try to get it from the editor once it's ready
    this.storeEditorContent()
  }
  
  storeEditorContent() {
    const wysiwygComponent = document.querySelector('#right_column_content nfca-admin-wysiwyg-editor')
    if (wysiwygComponent && wysiwygComponent._quillInstance) {
      const content = wysiwygComponent._quillInstance.root.innerHTML
      if (content && content !== '<p><br></p>') {
        this.originalHtmlContent = content
        this.savedContent = content // Also update savedContent
      }
    } else {
      // If not ready yet, try again
      setTimeout(() => this.storeEditorContent(), 100)
    }
  }

  toggle(event) {
    const rightColumnContent = document.getElementById('right_column_content')
    const hiddenField = document.getElementById('page_right_column_text')
    
    if (event.target.checked) {
      // Show the right column editor
      rightColumnContent.style.display = 'block'
      
      // Restore HTML content if the field was cleared
      if (this.savedContent) {
        // Set the hidden field immediately
        hiddenField.value = this.savedContent
        
        // Try to restore content to Quill with retries
        this.restoreQuillContent(0)
      }
    } else {
      // First, store the current content before hiding/clearing
      const wysiwygComponent = rightColumnContent.querySelector('nfca-admin-wysiwyg-editor')
      if (wysiwygComponent && wysiwygComponent._quillInstance) {
        const currentContent = wysiwygComponent._quillInstance.root.innerHTML
        if (currentContent && currentContent !== '<p><br></p>') {
          this.savedContent = currentContent
        }
      } else if (hiddenField && hiddenField.value) {
        // Fallback to hidden field value
        this.savedContent = hiddenField.value
      } else if (this.originalHtmlContent) {
        // Fallback to original content
        this.savedContent = this.originalHtmlContent
      }
      
      // Hide the right column editor
      rightColumnContent.style.display = 'none'
      
      // Clear the hidden field value
      if (hiddenField) {
        hiddenField.value = ''
      }
      
      // Clear the Quill editor content
      if (wysiwygComponent && wysiwygComponent._quillInstance) {
        wysiwygComponent._quillInstance.setText('')
      }
    }
  }
  
  restoreQuillContent(attempt) {
    if (attempt > 10) {
      return
    }
    
    const rightColumnContent = document.getElementById('right_column_content')
    const wysiwygComponent = rightColumnContent.querySelector('nfca-admin-wysiwyg-editor')
    
    if (wysiwygComponent && wysiwygComponent._quillInstance) {
      // Use Quill's API to set the content from savedContent
      wysiwygComponent._quillInstance.root.innerHTML = this.savedContent
      // Trigger Quill to recognize the change
      wysiwygComponent._quillInstance.update()
    } else {
      // Try again in 50ms
      setTimeout(() => this.restoreQuillContent(attempt + 1), 50)
    }
  }
}